<template>
    <div class="container">
        <div class="content">
            <div class="content-component">
                <basicComponent
                    :active_id="active_id"
                    :formData="formData"
                    ref="childRef"
                ></basicComponent>
            </div>
            <div class="content-phone">
                <!-- 删除组件 -->
                <!-- 表单名称  提交按钮 -->
                <div
                    class="del-btn"
                    v-if="
                        operateData.visable &&
                        operateData.type != 1 &&
                        operateData.type != 20
                    "
                    :style="`top: ${
                        operateData.top +
                        operateData.first_top -
                        operateData.top_cha
                    }px;left: ${operateData.left}px;`"
                >
                    <Icon
                        type="ios-arrow-up"
                        size="24"
                        color="#999999"
                        @click="goMoveUp(operateData.index)"
                    />
                    <Icon
                        type="ios-arrow-down"
                        size="24"
                        color="#999999"
                        @click="goMoveDown(operateData.index)"
                    />
                    <Icon
                        class="mt12 mb12"
                        type="md-add"
                        size="24"
                        color="#999999"
                        @click="callMenuClick(operateData.type)"
                    />
                    <Icon
                        type="md-trash"
                        size="24"
                        color="#999999"
                        @click.stop.prevent="delBtn(operateData.index)"
                    />
                </div>
                <div class="phone-div">
                    <div class="phone" ref="xqBox">
                        <draggable
                            class="w375"
                            v-model="formData"
                            chosen-class="chosen"
                            force-fallback="true"
                            group="people"
                            animation="500"
                            :handle="'.dragg'"
                            @start="onStart"
                            @end="onEnd"
                        >
                            <transition-group>
                                <div
                                    v-for="(items, index) in formData"
                                    :key="index + 'a'"
                                    @click.stop.prevent="
                                        clickActive(items, index, $event)
                                    "
                                >
                                    <div
                                        :class="
                                            active_id == index
                                                ? 'phone-active'
                                                : 'phone-default'
                                        "
                                    >
                                        <!-- 表单名称 -->
                                        <formName
                                            class="dragg"
                                            :componentsData="items"
                                        ></formName>
                                        <!-- 单行文本 -->
                                        <singleLineText
                                            class="dragg"
                                            :componentsData="items"
                                        ></singleLineText>
                                        <!-- 多行文本 -->
                                        <multiLineText
                                            class="dragg"
                                            :componentsData="items"
                                        ></multiLineText>
                                        <!-- 下拉菜单 -->
                                        <dropDown
                                            class="dragg"
                                            :componentsData="items"
                                        ></dropDown>
                                        <!-- 开关 -->
                                        <switchItem
                                            class="dragg"
                                            :componentsData="items"
                                        ></switchItem>
                                        <!-- 单选框 -->
                                        <radioItem
                                            class="dragg"
                                            :componentsData="items"
                                        ></radioItem>
                                        <!-- 多选框 -->
                                        <checkboxItem
                                            class="dragg"
                                            :componentsData="items"
                                        ></checkboxItem>
                                        <!-- 手机验证码 -->
                                        <phoneCode
                                            class="dragg"
                                            :componentsData="items"
                                        ></phoneCode>
                                        <!-- 定位 -->
                                        <locationItem
                                            class="dragg"
                                            :componentsData="items"
                                        ></locationItem>
                                        <!-- 日历 -->
                                        <calendarItem
                                            class="dragg"
                                            :componentsData="items"
                                        ></calendarItem>
                                        <!-- 协议 -->
                                        <agreementItem
                                            class="dragg"
                                            :componentsData="items"
                                        ></agreementItem>
                                        <!-- 表格 -->
                                        <tableItem
                                            class="dragg"
                                            :componentsData="items"
                                        ></tableItem>
                                        <!-- 自增表格 -->
                                        <autoTable
                                            class="dragg"
                                            :componentsData="items"
                                        ></autoTable>
                                        <!-- 检查项 -->
                                        <checkItem
                                            class="dragg"
                                            :componentsData="items"
                                        ></checkItem>
                                        <!-- 手写签名 -->
                                        <signatureItem
                                            class="dragg"
                                            :componentsData="items"
                                        ></signatureItem>
                                        <!-- 上传图片 -->
                                        <uploadImage
                                            class="dragg"
                                            :componentsData="items"
                                        ></uploadImage>
                                        <!-- 上传视频 -->
                                        <uploadVideo
                                            class="dragg"
                                            :componentsData="items"
                                        ></uploadVideo>
                                        <!-- 填写者姓名 -->
                                        <fillerName
                                            class="dragg"
                                            :componentsData="items"
                                        ></fillerName>
                                        <!-- 授权手机号 -->
                                        <authPhone
                                            class="dragg"
                                            :componentsData="items"
                                        ></authPhone>
                                        <!-- AI识别 -->
                                        <aiRecognition
                                            class="dragg"
                                            :componentsData="items"
                                        ></aiRecognition>
                                        <!-- 十字表格 -->
                                        <crossTable
                                            class="dragg"
                                            :componentsData="items"
                                        ></crossTable>
                                    </div>
                                </div>
                            </transition-group>
                        </draggable>
                    </div>
                    <!-- 提交按钮 -->
                    <div
                        style="width: 376px"
                        v-if="formData.some((item) => item.type == 20)"
                        @click.stop.prevent="clickActive(null, null, $event)"
                    >
                        <submitButton
                            :componentsData="
                                formData.find((item) => item.type == 20)
                            "
                            :style="
                                newFormData.type == 20
                                    ? 'border: 2px dashed #ff761d;'
                                    : ''
                            "
                        ></submitButton>
                    </div>
                </div>
            </div>
            <div class="content-style">
                <!-- 表单名称 -->
                <formNameStyle
                    v-if="newFormData.content && newFormData.type == 1"
                    :newFormData="newFormData"
                ></formNameStyle>
                <!-- 单行文本 -->
                <singleLineTextStyle
                    v-if="newFormData.content && newFormData.type == 2"
                    :newFormData="newFormData"
                ></singleLineTextStyle>
                <!-- 多行文本 -->
                <multiLineTextStyle
                    v-if="newFormData.content && newFormData.type == 3"
                    :newFormData="newFormData"
                ></multiLineTextStyle>
                <!-- 下拉菜单 -->
                <dropDownStyle
                    v-if="newFormData.content && newFormData.type == 4"
                    :newFormData="newFormData"
                ></dropDownStyle>
                <!-- 开关 -->
                <switchItemStyle
                    v-if="newFormData.content && newFormData.type == 5"
                    :newFormData="newFormData"
                ></switchItemStyle>
                <!-- 单选框 -->
                <radioItemStyle
                    v-if="newFormData.content && newFormData.type == 6"
                    :newFormData="newFormData"
                ></radioItemStyle>
                <!-- 多选框 -->
                <checkboxItemStyle
                    v-if="newFormData.content && newFormData.type == 7"
                    :newFormData="newFormData"
                ></checkboxItemStyle>
                <!-- 手机验证码 -->
                <phoneCodeStyle
                    v-if="newFormData.content && newFormData.type == 8"
                    :newFormData="newFormData"
                ></phoneCodeStyle>
                <!-- 定位 -->
                <locationItemStyle
                    v-if="newFormData.content && newFormData.type == 9"
                    :newFormData="newFormData"
                ></locationItemStyle>
                <!-- 日历 -->
                <calendarItemStyle
                    v-if="newFormData.content && newFormData.type == 10"
                    :newFormData="newFormData"
                ></calendarItemStyle>
                <!-- 协议 -->
                <agreementItemStyle
                    v-if="newFormData.content && newFormData.type == 11"
                    :newFormData="newFormData"
                ></agreementItemStyle>
                <!-- 表格 -->
                <tableItemStyle
                    v-if="newFormData.content && newFormData.type == 12"
                    :newFormData="newFormData"
                ></tableItemStyle>
                <!-- 自增表格 -->
                <autoTableStyle
                    v-if="newFormData.content && newFormData.type == 13"
                    :newFormData="newFormData"
                ></autoTableStyle>
                <!-- 检查项 -->
                <checkItemStyle
                    v-if="newFormData.content && newFormData.type == 14"
                    :newFormData="newFormData"
                ></checkItemStyle>
                <!-- 手写签名 -->
                <signatureItemStyle
                    v-if="newFormData.content && newFormData.type == 15"
                    :newFormData="newFormData"
                ></signatureItemStyle>
                <!-- 上传图片 -->
                <uploadImageStyle
                    v-if="newFormData.content && newFormData.type == 16"
                    :newFormData="newFormData"
                ></uploadImageStyle>
                <!-- 上传视频 -->
                <uploadVideoStyle
                    v-if="newFormData.content && newFormData.type == 17"
                    :newFormData="newFormData"
                ></uploadVideoStyle>
                <!-- 填写者姓名 -->
                <fillerNameStyle
                    v-if="newFormData.content && newFormData.type == 18"
                    :newFormData="newFormData"
                ></fillerNameStyle>
                <!-- 授权手机号 -->
                <authPhoneStyle
                    v-if="newFormData.content && newFormData.type == 19"
                    :newFormData="newFormData"
                ></authPhoneStyle>
                <!-- 提交按钮 -->
                <submitButtonStyle
                    v-if="newFormData.content && newFormData.type == 20"
                    :newFormData="newFormData"
                ></submitButtonStyle>
                <!-- AI识别 -->
                <aiRecognitionStyle
                    v-if="newFormData.content && newFormData.type == 21"
                    :newFormData="newFormData"
                ></aiRecognitionStyle>
                <!-- 十字表格 -->
                <crossTableStyle
                    v-if="newFormData.content && newFormData.type == 22"
                    :newFormData="newFormData"
                ></crossTableStyle>
            </div>
        </div>
        <div class="footer">
            <Button class="theme-bc theme-default-color" @click="goSubmit"
                >确定</Button
            >
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import basicComponent from "@/components/addForm/basicComponent.vue";
import formName from "@/components/addForm/formName.vue";
import formNameStyle from "@/components/addForm/formNameStyle.vue";
import singleLineText from "@/components/addForm/singleLineText.vue";
import singleLineTextStyle from "@/components/addForm/singleLineTextStyle.vue";
import multiLineText from "@/components/addForm/multiLineText.vue";
import multiLineTextStyle from "@/components/addForm/multiLineTextStyle.vue";
import dropDown from "@/components/addForm/dropDown.vue";
import dropDownStyle from "@/components/addForm/dropDownStyle.vue";
import switchItem from "@/components/addForm/switchItem.vue";
import switchItemStyle from "@/components/addForm/switchItemStyle.vue";
import radioItem from "@/components/addForm/radioItem.vue";
import radioItemStyle from "@/components/addForm/radioItemStyle.vue";
import checkboxItem from "@/components/addForm/checkboxItem.vue";
import checkboxItemStyle from "@/components/addForm/checkboxItemStyle.vue";
import phoneCode from "@/components/addForm/phoneCode.vue";
import phoneCodeStyle from "@/components/addForm/phoneCodeStyle.vue";
import locationItem from "@/components/addForm/locationItem.vue";
import locationItemStyle from "@/components/addForm/locationItemStyle.vue";
import calendarItem from "@/components/addForm/calendarItem.vue";
import calendarItemStyle from "@/components/addForm/calendarItemStyle.vue";
import agreementItem from "@/components/addForm/agreementItem.vue";
import agreementItemStyle from "@/components/addForm/agreementItemStyle.vue";
import tableItem from "@/components/addForm/tableItem.vue";
import tableItemStyle from "@/components/addForm/tableItemStyle.vue";
import autoTable from "@/components/addForm/autoTable.vue";
import autoTableStyle from "@/components/addForm/autoTableStyle.vue";
import checkItem from "@/components/addForm/checkItem.vue";
import checkItemStyle from "@/components/addForm/checkItemStyle.vue";
import signatureItem from "@/components/addForm/signatureItem.vue";
import signatureItemStyle from "@/components/addForm/signatureItemStyle.vue";
import uploadImage from "@/components/addForm/uploadImage.vue";
import uploadImageStyle from "@/components/addForm/uploadImageStyle.vue";
import uploadVideo from "@/components/addForm/uploadVideo.vue";
import uploadVideoStyle from "@/components/addForm/uploadVideoStyle.vue";
import fillerName from "@/components/addForm/fillerName.vue";
import fillerNameStyle from "@/components/addForm/fillerNameStyle.vue";
import authPhone from "@/components/addForm/authPhone.vue";
import authPhoneStyle from "@/components/addForm/authPhoneStyle.vue";
import submitButton from "@/components/addForm/submitButton.vue";
import submitButtonStyle from "@/components/addForm/submitButtonStyle.vue";
import aiRecognition from "@/components/addForm/aiRecognition.vue";
import aiRecognitionStyle from "@/components/addForm/aiRecognitionStyle.vue";
import crossTable from "@/components/addForm/crossTable.vue";
import crossTableStyle from "@/components/addForm/crossTableStyle.vue";
export default {
    components: {
        draggable,
        basicComponent,
        formName,
        formNameStyle,
        singleLineText,
        singleLineTextStyle,
        multiLineText,
        multiLineTextStyle,
        dropDown,
        dropDownStyle,
        switchItem,
        switchItemStyle,
        radioItem,
        radioItemStyle,
        checkboxItem,
        checkboxItemStyle,
        phoneCode,
        phoneCodeStyle,
        locationItem,
        locationItemStyle,
        calendarItem,
        calendarItemStyle,
        agreementItem,
        agreementItemStyle,
        tableItem,
        tableItemStyle,
        autoTable,
        autoTableStyle,
        checkItem,
        checkItemStyle,
        signatureItem,
        signatureItemStyle,
        uploadImage,
        uploadImageStyle,
        uploadVideo,
        uploadVideoStyle,
        fillerName,
        fillerNameStyle,
        authPhone,
        authPhoneStyle,
        submitButton,
        submitButtonStyle,
        aiRecognition,
        aiRecognitionStyle,
        crossTable,
        crossTableStyle,
    },
    props: {
        // 初始表单数据（编辑已有表单时由父组件传入）
        formList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            operateData: {
                top: 0,
                left: 0,
                visable: false,
                first_top: 0,
                top_cha: 0,
                index: 0,
                type: 0,
            },
            formData: [],
            active_id: -1,
            newFormData: {},
        };
    },
    watch: {
        formList: {
            handler(val) {
                // 父组件传入新数据时，重新初始化表单
                this.formData = JSON.parse(JSON.stringify(val || []));
            },
            immediate: true,
        },
    },
    computed: {
        xqBox() {
            return this.$refs.xqBox;
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.xqBox.addEventListener("scroll", this.handleScroll);
        });
    },
    methods: {
        callMenuClick(e) {
            this.$refs.childRef.menuClick(e);
        },
        handleScroll() {
            const scrollTop = this.xqBox.scrollTop;
            this.operateData.top_cha = scrollTop;
            console.log("滚动距离", scrollTop);
        },
        clickActive(items, index, event) {
            this.toShow(event);
            if (items === null) {
                console.log("点击了外面的div");
                this.active_id = -1;
                this.operateData.index = -1;
                const targetItem = this.formData.find(
                    (item) => item.type === 20
                );
                if (targetItem) {
                    this.newFormData = targetItem;
                    this.operateData.type = targetItem.type;
                }
                return;
            }
            console.log("点击了列表项", items, index);
            this.active_id = index;
            this.operateData.index = index;
            this.newFormData = items;
            this.operateData.type = items.type;
        },
        toShow(event) {
            const parentElement = event.currentTarget;
            const rect = parentElement.getBoundingClientRect();
            this.operateData.visable = true;
            this.operateData.top = rect.top;
            this.operateData.left = rect.left + 380;
            this.operateData.first_top = this.xqBox.scrollTop;
        },
        // 删除
        delBtn(e) {
            console.log("e", e);
            this.formData.splice(e, 1);
            this.newFormData = {};
            this.active_id = -1;
            this.operateData.visable = false;
        },
        // 上移
        goMoveUp(index) {
            this.moveElement(this.formData, index, index - 1);
            this.active_id = index - 1;
            this.operateData.visable = false;
            console.log("this.formData", this.formData);
        },
        // 下移
        goMoveDown(index) {
            this.moveElement(this.formData, index, index + 1);
            this.active_id = index + 1;
            this.operateData.visable = false;
            console.log("this.formData", this.formData);
        },
        // 移动时
        onStart(e) {
            console.log("触发移动", e.oldDraggableIndex);
            this.drag = true;
            this.active_id = e.oldDraggableIndex;
        },
        // 移动结束
        onEnd(e) {
            console.log("移动结束", e.newDraggableIndex);
            this.drag = false;
            this.active_id = e.newDraggableIndex;
            this.newFormData = this.formData[this.active_id];
            console.log("onEnd", this.formData);
        },
        // 调整数组索性位置
        moveElement(array, fromIndex, toIndex) {
            // 从原位置移除元素
            const element = array.splice(fromIndex, 1)[0];
            // 将元素插入到新位置
            array.splice(toIndex, 0, element);
        },
        // 确定：把设计好的表单数据回传给父组件
        goSubmit() {
            this.$emit("submit", this.formData);
        },
    },
};
</script>
  
<style scoped>
.container {
    background-color: #f5f6fa;
}
.content {
    height: 600px;
    margin-bottom: 40px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.content-component {
    min-width: 160px;
    width: 320px;
    max-width: 320px;
    height: 600px;
    flex: 2;
    overflow: auto;
}
.content-phone {
    margin: 0 24px;
    min-width: 450px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 4;
    overflow: hidden;
}
.content-style {
    height: 600px;
    min-width: 440px;
    flex: 3;
    overflow: auto;
}
.phone {
    height: 535px;
    position: relative;
    width: 376px !important;
    min-width: 376px !important;
    max-width: 376px !important;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    transform: translate(0);
    overflow-y: auto;
    background-color: #ccc;
}
.footer {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 66px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #dcdee2;
    z-index: 999;
}
.phone-default {
    position: relative;
    width: 375px !important;
    cursor: pointer;
    z-index: 999;
}
.phone-active {
    position: relative;
    width: 375px !important;
    border: 2px dashed #ff761d !important;
    cursor: pointer;
    z-index: 999;
}
/* draggable 拖拽的元素被选中时样式 */
.chosen {
    background-color: #ecf0f1;
    opacity: 0.8;
}
/* 删除组件 */
.del-btn {
    padding: 12px;
    cursor: pointer;
    background: #ffffff;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    z-index: 1000;
}
.del-btn26 {
    padding: 12px;
    cursor: pointer;
    background: #ffffff;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    z-index: 1000;
    bottom: 123px;
}
.pop {
    padding: 12px;
    background-color: rgb(226, 240, 255);
    color: #bebebe;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
}
.phone-div {
    width: 450px;
    min-width: 450px;
    max-width: 450px;
    overflow-x: hidden;
}
.bg-img {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    min-height: 100%;
    object-fit: cover; /* 填充整个区域（无变形裁剪） */
    display: block;
}
.w375 {
    width: 375px !important;
    min-width: 375px !important;
    max-width: 375px !important;
}
/* 滚动条整体部分 */
::-webkit-scrollbar {
    width: 1px;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
    background-color: darkgrey;
}
/* 滚动条轨道 */
::-webkit-scrollbar-track {
    background: #f1f1f1;
}
::v-deep
    .ivu-radio-group
    .ivu-radio-wrapper-checked
    .ivu-radio-checked
    .ivu-radio-inner {
    border: 2px solid #ff761d;
}
::v-deep
    .ivu-radio-group
    .ivu-radio-wrapper-checked
    .ivu-radio-checked
    .ivu-radio-inner:after {
    background-color: #fff;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
::v-deep .ivu-menu.ivu-menu-light.ivu-menu-horizontal {
    display: flex;
    align-items: center;
    justify-content: space-around;
}
::v-deep .ivu-menu-item {
    font-size: 16px;
}
::v-deep .ivu-menu-item:hover {
    font-size: 16px;
    color: #ff761d !important;
    border-bottom: 2px solid #ff761d !important;
}
::v-deep .ivu-menu-item.ivu-menu-item-active.ivu-menu-item-selected {
    color: #ff761d;
    font-size: 16px;
    border-bottom: 2px solid #ff761d !important;
}
::v-deep .ivu-form-item {
    margin-bottom: 6px !important;
}
</style>